import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from './common/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/components/header/header.component';
import { FooterComponent } from './common/components/footer/footer.component';
import { LocalStorageService } from './common/services/local-storage.service';
import { TokenInterceptor } from './common/interceptors/token.interceptor';
import { AuthService } from './common/services/auth.service';
import { TranslationService } from './common/services/translation.service';
import { EnvServiceProvider } from './env.service.provider';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxUiLoaderModule, NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderService } from "ngx-ui-loader";
import { VerifyPaymentComponent } from './common/components/verify-payment/verify-payment.component';
import { DatePipe } from '@angular/common';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { UserIdleComponent } from './common/components/user-idle/user-idle.component';
import { SharedSignalsService } from './common/services/shared-signals.service';
import { SiteHeaderComponent } from './common/components/site-header/site-header.component';
import { SliderModule } from 'primeng/slider';
import { EnvService } from './env.service';
import { PressReleaseComponent } from './press-release/press-release.component';
import { PartnerSignupComponent } from './partners/partner-signup/partner-signup.component';
import { ShopsComponent } from './partners/shops/shops.component';
import { MerchantHomeComponent } from './partners/merchant-home/merchant-home.component';
import { PartnerFaqComponent } from './partners/merchant-home/partner-faq/partner-faq.component';
import { PartnerBannerComponent } from './partners/merchant-home/partner-banner/partner-banner.component';
import { TrustedParternsComponent } from './partners/merchant-home/trusted-parterns/trusted-parterns.component';
import { TalyIntegrationComponent } from './partners/merchant-home/taly-integration/taly-integration.component';
import { SellWithTalyComponent } from './partners/merchant-home/sell-with-taly/sell-with-taly.component';
import { WithoutTalyComponent } from './partners/merchant-home/taly-payment-option/without-taly/without-taly.component';
import { WithTalyComponent } from './partners/merchant-home/taly-payment-option/with-taly/with-taly.component';
import { OrderDetailsComponent } from './partners/merchant-home/taly-payment-option/order-details/order-details.component';
//import { PaymentMethodComponent } from './checkout/components/choose-payment-method/payment-method/payment-method.component';
import { RequestFormComponent } from './partners/partner-signup/request-form/request-form.component';
import { BusinessWithTalyComponent } from './partners/partner-signup/business-with-taly/business-with-taly.component';
import { TalyPaymentOptionComponent } from './partners/merchant-home/taly-payment-option/taly-payment-option.component';
import { PaymentMethodComponent } from './partners/merchant-home/taly-payment-option/payment-method/payment-method.component';


const spinnerConfig: NgxUiLoaderConfig = {
  "bgsColor": "#0E6FF7",
  "bgsOpacity": 0.5,
  "bgsPosition": "center-center",
  "bgsSize": 40,
  "bgsType": "circle",
  "fastFadeOut": true,
  "fgsColor": "#0E6FF7",
  "fgsPosition": "center-center",
  "fgsSize": 40,
  "fgsType": "double-bounce",
  "logoPosition": "center-center",
  "logoUrl": "assets/images/taly-dark-icon.svg",
  "overlayBorderRadius": "0",
  "overlayColor": "rgb(255,255,255)",
  "pbColor": "#0E6FF7",
  "hasProgressBar": false,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        VerifyPaymentComponent,
        UserIdleComponent,
        SiteHeaderComponent,
        PressReleaseComponent,
        PartnerSignupComponent,
        ShopsComponent,
        MerchantHomeComponent,
        PartnerFaqComponent,
        PartnerBannerComponent,
        TalyPaymentOptionComponent,
        TrustedParternsComponent,
        TalyIntegrationComponent,
        SellWithTalyComponent,
        WithoutTalyComponent,
        WithTalyComponent,
        OrderDetailsComponent,
        PaymentMethodComponent,
        RequestFormComponent,
        BusinessWithTalyComponent
    ],
    exports: [
        SharedModule
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        SliderModule,
        FormsModule,
        NgIdleKeepaliveModule.forRoot(),
        NgxUiLoaderHttpModule.forRoot({
            showForeground: true,
            exclude: [
                "https://api.dev-taly.io/accounts/profile/retrieve-charge/",
                "https://api.dev-taly.io/accounts/payment/status",
                "https://api.dev-taly.io/accounts/profile/retrieve-charge/",
                "https://api.dev-taly.io/accounts/payment/status",
                "https://api.dev-taly.io/accounts/signup/nationalId/status",
                "https://api.dev-taly.io/accounts/signup/nationalId/status",
                "https://api.dev-taly.io/accounts/payment/order/status/",
                "https://api.dev-taly.io/accounts/payment/order/status/",
                "https://api.dev-taly.io/accounts/payment/processOrderPayment",
                "https://api.dev-taly.io/accounts/payment/processOrderPayment",
                "https://api.dev-taly.io/merchants/merchantProfile/v1/limited",
                "https://api.dev-taly.io/merchants/merchantProfile/v1/limited",
                "https://api.dev-taly.io/accounts/signup/cinet/authentication/status",
                "https://api.dev-taly.io/accounts/signup/token/otp",
                "https://api.dev-taly.io/accounts/profile/creditCard",
            ]
        }),
        NgxUiLoaderModule.forRoot(spinnerConfig),
        TranslateModule.forRoot({
            defaultLanguage: 'en-US',
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })], providers: [
        LocalStorageService,
        EnvServiceProvider,
        DatePipe,
        NgxUiLoaderService,
        AuthService,
        SharedSignalsService,
        EnvService,
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })

export class AppModule {
  constructor(private translationService: TranslationService) {
    this.translationService.init(); // Initialize the translation service
  }
}
